import { useMemo } from 'react'
import { staticImgsWebPreview } from './Constants'
import arrowLeft from 'assets/Images/arrow-left.png'
import arrowRight from 'assets/Images/arrow-right.png'
import { webContentStore } from 'state/setting/webContent'
import './styles/content-preview.scss'

const WebContent = () => {
  const {
    slides,
    heading,
    headingBefore,
    headingColored,
    headingAfter,
    description,
    buttonText,
    buttonLink,
    gallery,
    type,
    videoLink,
    imageLink,
    commonEventId,
    currentSlide,
    setCurrentSlide,
  } = webContentStore()

  const effectiveSlides = useMemo(() => {
    if (Array.isArray(slides) && slides.length > 0) return slides
    return [
      {
        id: 'preview-1',
        content: {
          heading,
          headingBefore,
          headingColored,
          headingAfter,
          description,
          buttonText,
          buttonLink,
        },
        type: type,
        videoLink: videoLink,
        imageLink: imageLink,
        commonEventId: commonEventId,
        gallery: Array.from({ length: 9 }, () => ''),
      },
    ]
  }, [
    slides,
    heading,
    headingBefore,
    headingColored,
    headingAfter,
    description,
    buttonText,
    buttonLink,
    type,
    videoLink,
    imageLink,
    commonEventId,
  ])

  const cleanedHeading = slides[currentSlide]?.content.heading?.replace(
    /^<p>|<\/p>$/g,
    '',
  )
  const cleanedDescription = slides[currentSlide]?.content.description?.replace(
    /^<p>|<\/p>$/g,
    '',
  )

  return (
    <div className={`bg`}>
      <div className="relative">
        <div className={`hero_container`}>
          <div className={`carousel_main_container`}>
            {effectiveSlides.map((carouselItem, index) => {
              return (
                <div
                  className={`carousel_item ${index === 0 && 'active'}`}
                  style={{
                    transform: `${
                      index < currentSlide
                        ? 'translateX(-110%)'
                        : index > currentSlide
                        ? 'translateX(110%)'
                        : 'translateX(0)'
                    }`,
                  }}
                  key={carouselItem.id + '-' + currentSlide}
                >
                  <div className={`carousel_content`}>
                    <div className={`heading`}>
                      <p
                        className={`heading1 main_heading`}
                        dangerouslySetInnerHTML={{ __html: cleanedHeading }}
                      ></p>
                    </div>
                    <p
                      className="para hero_para"
                      dangerouslySetInnerHTML={{
                        __html: cleanedDescription,
                      }}
                    ></p>
                    {carouselItem.content.buttonText && (
                      <a href={carouselItem.content.buttonLink} target="_blank">
                        <button className={`buttton`}>
                          {carouselItem.content.buttonText}
                        </button>
                      </a>
                    )}
                  </div>

                  <div className={`carousel_gallery`}>
                    {staticImgsWebPreview.map((staticImg, i) => {
                      return (
                        <div
                          className={`gallery_item ${[
                            `gallery_item_${i + 1}`,
                          ]}`}
                          key={i + '-' + currentSlide}
                        >
                          <div
                            className={`static_img ${[`static_img_${i + 1}`]}
                            }`}
                          >
                            <img
                              width={300}
                              height={300}
                              src={staticImg}
                              alt="img-content"
                              style={{ width: '100%', height: '100%' }}
                            />
                            {(() => {
                              const overlaySrc =
                                slides[currentSlide]?.gallery?.[i] || ''
                              return overlaySrc &&
                                overlaySrc.trim().length > 0 ? (
                                <div className={`overlay_image`}>
                                  <img
                                    width={300}
                                    height={300}
                                    src={overlaySrc}
                                    alt="img-content"
                                    className={`${[`overlay_image_${i + 1}`]}`}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      // objectFit: "cover",
                                      objectPosition: 'center',
                                    }}
                                  />
                                </div>
                              ) : null
                            })()}
                          </div>
                        </div>
                      )
                    })}

                    {slides[currentSlide]?.type !== 'none' ? (
                      <div className={`gall_main`}>
                        {slides[currentSlide]?.type === 'video' ? (
                          <div className={`video_container`}>
                            <iframe
                              src={slides[currentSlide]?.videoLink}
                              className={`video`}
                              allow="autoplay; encrypted-media"
                            ></iframe>
                          </div>
                        ) : slides[currentSlide]?.type === 'image' ? (
                          <div className="video_container">
                            <img
                              src={slides[currentSlide].imageLink}
                              alt="card_image"
                              style={{
                                objectFit: 'cover',
                                width: '100%',
                                height: '100%',
                                borderRadius: '12px',
                              }}
                            />
                          </div>
                        ) : (
                          <div className={`event_container`}>
                            <div className={`event_card`}>
                              <div className={`event_card_img`}>
                                <img
                                  src={slides[currentSlide]?.event?.coverPhoto}
                                  alt="img-content"
                                  width={500}
                                  height={500}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                  }}
                                />
                              </div>
                              <div className={`event_detail`}>
                                <h4 className="font12 b text-color-orange">
                                  {slides[currentSlide]?.event?.date}
                                </h4>
                                <h3 className="mt-5 font18 b">
                                  {slides[currentSlide]?.event?.name}
                                </h3>
                                <p className="mt-5 font14 b3">
                                  {slides[currentSlide]?.event?.venue}
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
              )
            })}
          </div>

          <div className={`func_btn_container`}>
            <button
              className={`arrow_button`}
              onClick={() => {
                const nextIndex =
                  currentSlide === 0
                    ? effectiveSlides.length - 1
                    : currentSlide - 1
                setCurrentSlide(nextIndex)
              }}
            >
              <img
                src={arrowLeft}
                width={50}
                height={50}
                alt="arrow-left"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </button>

            <div className={`dots_wrapper`}>
              {effectiveSlides.map((_, i) => {
                const active = i === currentSlide
                return (
                  <button
                    key={i}
                    onClick={() => setCurrentSlide(i)}
                    className={`custom-dot ${active ? 'active' : ''}`}
                    style={{
                      width: active ? '50px' : '6px',
                      height: '6px',
                      borderRadius: active ? '6px' : '50%',
                      margin: '0 5px',
                      backgroundColor: active ? '#262626' : '#26262633',
                      border: 'none',
                      cursor: 'pointer',
                    }}
                  />
                )
              })}
            </div>
            <button
              className={`arrow_button`}
              onClick={() => {
                const nextIndex =
                  currentSlide === effectiveSlides.length - 1
                    ? 0
                    : currentSlide + 1
                setCurrentSlide(nextIndex)
              }}
            >
              <img
                src={arrowRight}
                width={50}
                height={50}
                alt="arrow-right"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WebContent
